import { defineComponent as _defineComponent } from 'vue'
import type { Maybe } from '@/helpers/types';

import PictureComp from '@/components/picture/PictureComp.vue';
import SportWatchNowButton from '@/features/sports/components/ui/SportWatchNowButton.vue';
import CompetitorLogo from '@/features/sports/components/ui/CompetitorLogo.vue';
import LiveChip from '@/features/sports/components/ui/LiveChip.vue';
import NoOfferNotifier from '@/features/sports/components/global/NoOfferNotifier.vue';

import { ObjectType, SingleStepSportEvent, SportOffer } from '@/@types/graphql-types';
import { ClickoutUrl } from '@/helpers/clickout-helper';
import { BuyboxParam, trackClickOutSports } from '@/helpers/offer-helper';
import { SingleStepTeamContext } from '@/features/sports/helpers/config';
import { formatDate, formatTime } from '@/helpers/time-zone-helper';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useAppStore, useLanguageStore, useUserStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';
import { useRouter } from 'vue-router/composables';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventEncounterLarge',
  props: {
    listIndex: null,
    event: null,
    context: null,
    domainSessionId: { default: '' },
    isLive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { listIndex: number, event: SingleStepSportEvent, context: SingleStepTeamContext, domainSessionId: Maybe<string>, isLive?: boolean };



const { country, language, webLocale, locales } = useLanguageStore();
const { timeZone } = useUserStore();
const { xServeTrack } = useAppStore();
const { t } = useI18n();
const router = useRouter();

const competitors = computed(() => {
	return props.context.getCompetitors(props.event, webLocale.value);
});

const isDoublesEvent = computed(() => {
	return competitors.value.start.length === 2 && competitors.value.end.length === 2;
});

const eventTitle = computed(() => {
	const { key, params } = props.context.getEventTitle(props.event, webLocale.value);
	return t(key, params);
});

const stageHeading = computed(() => {
	return props.context.getStageHeading(props.event.content.competitionStage, t);
});

const eventDate = computed(() => {
	return formatDate(
		new Date(props.event.content.startAt),
		locales.value,
		webLocale.value,
		timeZone.value,
		language.value
	);
});

const eventTime = computed(() => {
	return formatTime(
		new Date(props.event.content.startAt),
		locales.value,
		webLocale.value,
		timeZone.value,
		language.value
	);
});

const watchNowOffer = computed(() => {
	return props.event.watchNowOffer as SportOffer | undefined;
});

const backdropImageUrl = computed(() => {
	return `/${ASSETS_DIR}/img/sports/jw-sports-backdrop-${props.context.sportType}-scaled.jpeg`;
});

const sportContext = computed(() => {
	return SnowplowSportContext.fromSportEventV2(props.event.sport, ObjectType.SportEvent, props.event);
});

function getOfferClickoutUrl(offer: SportOffer) {
	return new ClickoutUrl(offer)
		.addContexts(sportContext.value)
		.set('uct_country', country.value)
		.set('uct_buybox', BuyboxParam.Sport)
		.set('sid', props.domainSessionId)
		.set('uct_sport', props.event?.sport)
		.setCanary(xServeTrack.value);
}

const notifyMePayload = computed(() => {
	return {
		eventId: props.event.id,
		isNotificationActive: !!props.event.mysportlistEntry?.createdAt,
	};
});

function onCompetitionClick() {
	// tracking
	const sportContext = new SnowplowSportContext(props.event.sport, ObjectType.SportCompetition);
	TrackingHelper.trackEvent('userinteraction', { action: 'competition_clicked', property: 'card-double' }, [
		sportContext,
	]);
}

function onCardClick() {
	trackCardClick();
	router.push({ path: props.event.content.fullPath as string | undefined });
}

function trackCardClick() {
	TrackingHelper.trackEvent('userinteraction', { action: 'event_clicked', property: 'card-double' }, [
		sportContext.value,
	]);
}

function onClickOut() {
	if (watchNowOffer.value == null) return;

	trackClickOutSports(watchNowOffer.value, 0, props.listIndex, watchNowOffer.value.sportObjectType, 'card-double', [
		sportContext.value,
	]);
}

function onNoOfferNotifierClick() {
	TrackingHelper.trackEvent('userinteraction', { action: 'notify_me_clicked', property: 'card-double' }, [
		sportContext.value,
	]);
}

return { __sfc: true,props, country, language, webLocale, locales, timeZone, xServeTrack, t, router, competitors, isDoublesEvent, eventTitle, stageHeading, eventDate, eventTime, watchNowOffer, backdropImageUrl, sportContext, getOfferClickoutUrl, notifyMePayload, onCompetitionClick, onCardClick, trackCardClick, onClickOut, onNoOfferNotifierClick, PictureComp, SportWatchNowButton, CompetitorLogo, LiveChip, NoOfferNotifier }
}

})